// usePaddle.js
import { useEffect, useState } from 'react';
import {useDispatch, useSelector} from '../reduxHooks';
import { toggleAppSidebar, setIsEmbedded } from '../modules/app';
import { paddleTrackingUtil, appUtil } from '../utils';
import { useHistory } from 'react-router-dom';

const usePaddle = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const [, setPaddleReady] = useState(Boolean(window.Paddle));

  useEffect(() => {
    let cancelled = false;
    const setupPaddle = () => {
      const paddle = window.Paddle;
      if (cancelled || !enabled || !paddle) return;
      if (
        process.env.NODE_ENV === 'development' ||
        process.env.REACT_APP_PADDLE_ENV === 'sandbox'
      ) {
        paddle.Environment.set('sandbox');
      }
      paddle.Setup({
        vendor: parseInt(process.env.REACT_APP_PADDLE_ID || '0'),
        eventCallback: (eventData: any) => {
          paddleTrackingUtil.track(eventData);
        },
      });
      setPaddleReady(true);
      window.dispatchEvent(new Event('betareader:paddle-ready'));
    };

    if (enabled) {
      if (window.Paddle) {
        setupPaddle();
      } else {
        const existing = document.querySelector<HTMLScriptElement>('#paddle-js');
        const script = existing || document.createElement('script');
        script.id = 'paddle-js';
        script.src = 'https://cdn.paddle.com/paddle/paddle.js';
        script.addEventListener('load', setupPaddle, { once: true });
        if (!existing) document.head.appendChild(script);
      }
    }

    const unlisten = history.listen(() => {
      if (appUtil.isSmallScreen()) {
        dispatch(toggleAppSidebar(false));
      }
    });

    if (window.self !== window.top) {
      dispatch(setIsEmbedded(true));
    }

    // Cleanup on unmount
    return () => {
      cancelled = true;
      unlisten();
    };
  }, [dispatch, enabled, history]);

  useEffect(() => {
    const setupProfitWell = (subscriptionId: string | undefined) => {
      if (subscriptionId) {
        profitwell('start', { user_id: subscriptionId }); // eslint-disable-line
      }
    };
    if (enabled && userProfile) {
      setupProfitWell(userProfile.account?.subscription.externalId);
    }
  }, [
    enabled,
    userProfile,
    userProfile?.language,
    userProfile?.readerSettings?.colorMode,
  ]);
};

export default usePaddle;
